import { render, staticRenderFns } from "./PropertiesSold.vue?vue&type=template&id=53a828c5&scoped=true&"
import script from "./PropertiesSold.vue?vue&type=script&lang=ts&"
export * from "./PropertiesSold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a828c5",
  null
  
)

export default component.exports